module.exports = __webpack_public_path__ + "media/dashboard/assets/images/credit-card/jcb-29b6c8d4e145e807c61b4cdd13e5a31c.svg";